import { Grid, Radio, TextField, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, formateDate, searchArray, sortItemsBySelection } from '../utils/Utils';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import Image from '../common/Image';
import FileSeachIcon from '../../assets/FileSearchIcon';
import ZeroState from '../common/ZeroState';

const useStyle = makeStyles({
  searchInput: {
    width: '90%',
    padding: '10px',
    background: '#fff',
    borderRadius: '10px',
  },
  journeyContainer: {
    width: '92%',
    height: '55vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  journy: {
    width: '97%',
    height: '110px',
    borderRadius: '10px',
    border: '1px solid #E4E7EC',
    background: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 10px',
  },
  profilePic: {
    height: '75px',
    width: '8%',
    borderRadius: '5px',
    overflow: 'hidden',
  },
  info: {
    height: '90px',
    width: '94%',
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    height: '83px',
    width: '92%',
    padding: '0px 10px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginTop: '5px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#10182B',
  },
  date: {
    marginTop: '5px',
    fontSize: '13px',
    fontWeight: '500',
    color: '#667085',
  },
});

export default function JourneyList({ selectedJ, setSelectedJ, callFrom, dealershipId }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const delaershipHeader = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const [searchVal, setSearchVal] = useState('');
  const [journeyList, setJourneyList] = useState([]);
  const [filteredJ, setFilteredJ] = useState([]);
  const [dealerId, setDealerId] = useState(null);

  useState(() => {
    if (callFrom === 'px') {
      setDealerId(dealershipId);
    } else {
      setDealerId(delaershipHeader.id);
    }
  }, [delaershipHeader]);

  useEffect(() => {
    getJourneys();
  }, []);

  useEffect(() => {
    setFilteredJ(journeyList);
  }, [journeyList]);

  const getJourneys = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.DEALER_JOURNEYLIST.replace('ID', dealerId));
      setJourneyList(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleSearch = (e) => {
    const searchKey = e.target.value;
    setSearchVal(searchKey);
    const filtered = searchArray(journeyList, ['title'], searchKey);
    setFilteredJ(filtered);
  };

  // Selected list should move up in the list
  const sortedJourneys = sortItemsBySelection(selectedJ.id ? [selectedJ.id] : [], filteredJ, 'id');

  return (
    <>
      <TextField
        placeholder="Search journey"
        className={classes.searchInput}
        value={searchVal}
        onChange={handleSearch}
        InputProps={{ disableUnderline: true }}
      />
      <Grid className={classes.journeyContainer}>
        {sortedJourneys.length > 0 ? (
          sortedJourneys.map((j) => (
            <Grid className={classes.journy} key={j.id}>
              <Grid style={{ height: '90px', width: '6%' }}>
                <Radio
                  onClick={() => setSelectedJ(j)}
                  checked={j.id === selectedJ.id}
                  style={{ ...(j.id === selectedJ.id ? { color: '#622fee' } : {}) }}
                />
              </Grid>
              <Grid className={classes.info}>
                <Grid className={classes.profilePic}>
                  <Image
                    src={j.thumbnail}
                    alt="profile"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </Grid>
                <Grid className={classes.content}>
                  <Typography variant="p" className={classes.title}>
                    {j.title}
                  </Typography>
                  <Typography variant="p" className={classes.date}>
                    {formateDate(j.publishDate)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))
        ) : (
          <Grid style={{ width: '90%', margin: '0px auto' }}>
            <ZeroState
              Icon={FileSeachIcon}
              text="No  journey found."
              style={{ paddingBottom: '100px' }}
              cardWidth="100%"
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}
